export default "__VITE_ASSET__c1d1cab4__"